export default __webpack_public_path__ + "static/media/promote.ffacb123.svg";